module.exports = __webpack_public_path__ + "img/award-ar.a026a2e2.png";